<template>
	<div class="page-container">
		<head-top head-title="消息中心" goBack="true"></head-top>

		<div class="messages-page">
			<van-tabs v-model="activeTab" animated @change="onTabChange">
				<van-tab title="系统消息"></van-tab>
				<van-tab title="个人消息"></van-tab>
			</van-tabs>

			<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
				<van-empty v-if="!loading && finished && messages.length === 0" description="暂无消息" />
				<van-list :offset="40" v-else v-model="loading" :finished="finished" :immediate-check="false"
					:finished-text="finished ? '没有更多了~' : ''" @load="onLoad">
					<div class="message-list">
						<div class="message-item bg_a flex_c" v-for="item in messages" :key="item.id"
							@click="goDetail(item)">
							<div class="message-unread" v-if="activeTab === 1 && !item.isRead"></div>
							<div class="message-content">
								<div class="message-title ellipsis_1" v-if="!activeTab">
									{{ item.title }}
								</div>
								<div class="content-info" v-if="activeTab">
									{{ item.content }}
								</div>
								<div class="message-time">{{ item.createTime }}</div>
							</div>
							<van-icon name="arrow" class="message-arrow" v-if="activeTab === 0" />
						</div>
					</div>
				</van-list>
			</van-pull-refresh>
		</div>

		<div class="back-to-top" :class="{ show: showBackToTop }" @click="scrollToTop">
			<van-icon name="back-top" />
		</div>
	</div>
</template>

<script>
	import headTop from '@/components/common/head.vue'
	import {
		getLoginMember,
		getNoticeList,
		getMemberNoticeList,
		readAllMemberNotice
	} from '@/apis/api.js'

	export default {
		name: 'Messages',
		components: {
			headTop: headTop
		},
		data() {
			return {
				activeTab: 1,
				messages: [],
				showBackToTop: false,
				leftToDetail: false,

				pageNum: 0,
				total: 0,
				pageSize:10,
				loading: false,
				finished: false,
				refreshing: false
			}
		},
		beforeRouteLeave(to, from, next) {
			this.leftToDetail = to.name === 'MessageDetail'
			next()
		},
		mounted() {			
			if (!getLoginMember()) {
				this.$router.push('/login?redirect=' + encodeURIComponent(this.$route.fullPath))
				return
			}
			window.addEventListener('scroll', this.handleScroll)
		},
		activated() {
			if (this.$route.params.hasUnread) {
				readAllMemberNotice()
			}
			if (this.leftToDetail) {
				this.leftToDetail = false
			} else {
				this.activeTab = 1
				this.pageNum = 0
				this.total = 0
				this.messages = []
				this.loading = false
				this.finished = false
				this.getList()
			}
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll)
		},
		methods: {
			
			getList() {
				this.pageNum++
				const api = this.activeTab === 0 ? getNoticeList : getMemberNoticeList
				api({
						pageNum: this.pageNum,
						pageSize: this.pageSize
					})
					.then(res => {
						const rows = res.rows || []
						const total = res.total || 0
						this.total = total
						this.messages = this.messages.concat(rows)
						if (this.messages.length >= this.total) {
							this.finished = true
						} else {
							this.finished = false
						}
					})
					.catch(e => {
						this.finished = true
						if (!e.handled) {
							this.$toast('加载失败')
						}
					})
					.finally(() => {
						this.loading = false
						this.refreshing = false
					})
			},
			onLoad() {
				if (this.refreshing || this.finished) {
					return
				}
				this.getList()
			},
			onRefresh() {
				this.pageNum = 0
				this.messages = []
				this.finished = false
				this.getList()
			},
			onTabChange() {
				this.messages = []
				this.pageNum = 0
				this.total = 0
				this.loading = true
				this.finished = false
				this.getList()
			},
			goDetail(item) {
				if (this.activeTab === 0) {
					this.$router.push(`/message_detail?id=${item.id}`)
				}
			},
			handleScroll() {
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				this.showBackToTop = scrollTop > 300
			},
			scrollToTop() {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.page-container {
		padding-top: 48px;

		.messages-page {
			.message-list {
				padding: 14px;

				.message-item {
					padding: 14px;
					border-radius: 8px;
					margin-bottom: 14px;
					position: relative;

					.message-unread {
						position: absolute;
						top: -3px;
						right: -3px;
						width: 10px;
						height: 10px;
						border-radius: 50%;
						z-index: 10;
						background-color: #ee0a24;
					}

					.message-content {
						flex: 1;

						.message-title {
							font-size: 14px;
							font-weight: bold;
							color: #333;
							margin-bottom: 6px;
						}
						
						.content-info {
							word-break: break-all;
							font-weight: bold;
							font-size: 14px;
							color: #333;
							line-height: 1.5;
							margin-bottom: 6px;
						}
						

						.message-time {
							font-size: 12px;
							color: #999;
						}
					}

					.message-arrow {
						flex: none;
						margin-left: 14px;
						font-size: 16px;
						color: #ccc;
					}
				}
			}
		}

		.back-to-top {
			position: fixed;
			right: 20px;
			bottom: 90px;
			width: 44px;
			height: 44px;
			background: #ffffff;
			border-radius: 50%;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
			display: flex;
			align-items: center;
			justify-content: center;
			opacity: 0;
			visibility: hidden;
			transition: all 0.3s ease;
			z-index: 1000;

			&.show {
				opacity: 1;
				visibility: visible;
			}

			.van-icon {
				font-size: 24px;
				color: #444;
			}
		}
	}
</style>